import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import AdminUserRoute from './components/auth/AdminUserRoute';
import Layout from './components/Layout';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import ForgotPassword from './components/auth/ForgotPassword';
import Dashboard from './dashboard/Dashboard';
import Expenses from './dashboard/Expenses';
import CreateExpenses from './dashboard/CreateExpenses';
import ExpenseReport from './dashboard/ExpenseReport';
import Profile from './components/Profile';
import Settings from './components/Settings';
import UserSettings from './components/UserSettings';
import UserManagement from './dashboard/UserManagement';
import Unauthorized from './components/Unauthorized';
import Savings from './components/savings/Savings';
import StaffSavingsDetail from './components/savings/StaffSavingsDetail';
import StaffRoute from './components/auth/StaffRoute';
import StaffSavings from './components/savings/StaffSavings';
import StockItems from './components/stock/StockItems';
import CreateStockItem from './components/stock/CreateStockItem';
import StockReport from './components/stock/StockReport';
import './App.css';

function App() {

  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          
          {/* Protected Routes */}
          <Route path="/" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            {/* Admin Only Routes */}
            <Route path="dashboard" element={
              <AdminRoute>
                <Dashboard />
              </AdminRoute>
            } />
            <Route path="reports" element={
              <AdminRoute>
                <ExpenseReport />
              </AdminRoute>
            } />
            <Route path="users" element={
              <AdminRoute>
                <UserManagement />
              </AdminRoute>
            } />
            <Route path="settings" element={
              <AdminRoute>
                <Settings />
              </AdminRoute>
            } />
            <Route path="savings" element={
              <AdminRoute>
                <Savings />
              </AdminRoute>
            } />
            <Route path="savings/:staffId" element={
              <AdminRoute>
                <StaffSavingsDetail />
              </AdminRoute>
            } />
            <Route path="stock" element={
              <AdminUserRoute>
                <StockItems />
              </AdminUserRoute>
            } />
            <Route path="stock/create" element={
              <AdminUserRoute>
                <CreateStockItem />
              </AdminUserRoute>
            } />
            <Route path="stock/reports" element={
              <AdminUserRoute>
                <StockReport />
              </AdminUserRoute>
            } />

            {/* Staff Routes */}
            <Route path="staff-savings" element={
              <StaffRoute>
                <StaffSavings />
              </StaffRoute>
            } />

            {/* User/Admin/Manager Routes (block staff) */}
            <Route path="expenses" element={
              <AdminUserRoute>
                <Expenses />
              </AdminUserRoute>
            } />
            <Route path="expenses/create" element={
              <AdminUserRoute>
                <CreateExpenses />
              </AdminUserRoute>
            } />
            <Route path="profile" element={<Profile />} />
            <Route path="user-settings" element={<UserSettings />} />
            
            {/* Default Route */}
            <Route index element={<Navigate to="/dashboard" />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
